export { default } from './UnscoredCardSkeleton'
